import Dialog from '../Reusable/Dialog';
import { useTranslation } from 'react-i18next';

type Props = {
  isActive: boolean;
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>;
  confirmLogout: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const LogoutConfirmation = ({ isActive, setIsActive, confirmLogout }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog
      isActive={isActive}
      setIsActive={setIsActive}
      title={t('T_LOGOUT_CONFIRMATION_HEADER')}
      text={<div className="mt-5 text-base">{t('T_LOGOUT_CONFIRMATION_SECONDARY')}</div>}
      secondaryButtonText={t('T_CANCEL') || ''}
      secondaryOnClick={() => {
        setIsActive(false);
      }}
      primaryButtonText={t('T_CONFIRM_LOGOUT') || ''}
      primaryOnClick={confirmLogout}
      primaryButtonWidth="40%"
    />
  );
};

export default LogoutConfirmation;
